const SAFETIES_EDIT_REQUIRED_FIELDS = [
  "bodyContent",
  "categoryId",
  "safetyTitle",
]

export const RequiredFields = {
  SAFETIES_EDIT_REQUIRED_FIELDS,
}
